module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-3.d135997c.jpg";